<template>
  <div id="WidokAkcesorium">
    <div id="widok">
      <template v-if="Object.keys(akcesorium).length>0 && !akcesorium.personal">
      <!-- " && !clearView"> -->
      <div id="KodNazwa">
        <table class="opisTable">
          <tr><td width=80>{{$t('message.kod')}}</td><td align=left>{{akcesorium.symbol}}</td></tr>
          <tr><td>{{$t('message.nazwa')}}</td><td style="text-align: left;">{{akcesorium.nazwa}}</td></tr>
        </table>
      </div>
      <div id="ImgAttr" class="row">
        <div id="Img">
          <template v-if="akcesorium.personal">
            <img :src="urlImagesProduct('WPK000')">
          </template>
          <template v-else>
            <img :src="urlImagesProduct(akcesorium.symbol)">
          </template>
        </div>
        <div id="Attr" class="col-sm kolumna kolumna-2">
          <table id="TabAttr" class="opisTable" style="text-align:left">
            <tr><td>{{$t('message.ilosc_u')}}</td><td>{{akcesorium.wysokosc_montazowa | decimal}}U</td></tr>
            <tr><td>{{$t('message.waga')}}</td><td>{{akcesorium.waga | decimal}} {{$t('message.kg')}}</td></tr>
            <tr v-if="$i18n.locale === 'pl'"><td>{{$t('message.cena_detal')}}</td><td><span class='price'>{{Number(akcesorium.cena).toFixed(2)}} {{$t('message.zl')}}</span></td></tr>
            <tr v-if="$i18n.locale === 'pl' && this.inputs.rabatValue > 0 && (!akcesorium.wyprzedaz || akcesorium.wyprzedaz !== 1) && (!akcesorium.promocja || akcesorium.promocja !== 1)">
              <td style="text-align:right; padding-right:5px">{{$t('message.po_rabacie')}}</td>
              <td><span style="color:red">{{Number(Number(akcesorium.cena) - (Number(akcesorium.cena) * (this.inputs.rabatValue) / 100)).toFixed(2)}} {{$t('message.zl')}}</span></td>
            </tr>
            <tr v-else><td></td><td>{{akcesorium.cena_opis}}</td></tr>
            <tr style="height:10px"></tr>
            <tr><td colspan="2">
              <button class="btn" style="color:rgb(59, 163, 255);font-size: 13px;" @click="open((($i18n.locale !== 'pl') ? 'en' : 'pl'),'karta',akcesorium.symbol)"><img src="../../assets/img/pdf2.svg" width="16"> {{$t('message.karta')}}</button>
            </td></tr>
          </table>
          <div class="wyprzedaz" v-if="akcesorium.wyprzedaz">{{$t('message.wyprzedaz')}}</div>
          <div class="promocja" v-if="akcesorium.promocja && akcesorium.promocja === 1">{{$t('message.promocja')}}</div>
<!-- {
  "symbol": "USF1816P",
  "id": 54251,
  "szerokosc_montazowa": null,
  "glebokosc_montazowa": null,
  "wysokosc_montazowa": "1.0000",
  "szerkosc": "270.0000",
  "wysokosc": "44.0000",
  "glebokosc": "181.0000",
  "nazwa": "Ultralink FastEthernet Switch,16xPoE+, 2xUpLink",
  "waga": "2.2000",
  "cena": "298.1000",
  "cena_old": null,
  "wyprzedaz": null,
  "promocja": 1,
  "cena_opis": "cena nie podlega rabatowaniu",
  "poza": null,
  "podzespoly": null
} -->

        </div>
      </div>
      <div id="Desc">
      </div>
      </template>
      <template v-if="Object.keys(akcesorium).length>0 && akcesorium.personal && !clearView">
      <div id="KodNazwa">
        <table class="opisTable">
          <!-- <tr><td width=80>{{$t('message.kod')}}</td><td align=left>{{akcesorium.symbol}}</td></tr> -->
          <tr><td>{{$t('message.kod')}}</td><td><input type="text" style="width:300px; background:white" v-model.lazy="kod" @change="setAttrSelectedAkcesorium()"/></td></tr>
          <tr><td>{{$t('message.nazwa')}}</td><td><input type="text" style="width:300px; background:white" v-model.lazy="nazwa" @change="setAttrSelectedAkcesorium()"/></td></tr>
        </table>
      </div>
      <div id="ImgAttr" class="row">
        <div id="Img">
          <template v-if="akcesorium.personal">
            <img :src="urlImagesProduct('WPK000')">
          </template>
          <template v-else>
            <img :src="urlImagesProduct(akcesorium.symbol)">
          </template>
        </div>
        <div id="Attr" class="col-sm kolumna kolumna-2">
          <table id="TabAttr" class="opisTable" style="text-align:left">
            <tr><td>{{$t('message.ilosc_u')}}</td><td><input type="number" style="width:50px; background:white" min=1 max=10 v-model.lazy="iloscU" @change="setAttrSelectedAkcesorium()"/>U</td></tr>
            <tr><td>{{$t('message.waga')}}</td><td>{{akcesorium.waga | decimal}} {{$t('message.kg')}}</td></tr>
            <tr v-if="$i18n.locale === 'pl'">
              <td>{{$t('message.cena_detal')}}</td><td><span class='price'>{{Number(akcesorium.cena)}} {{$t('message.zl')}}</span></td>
            </tr>
            <tr v-if="$i18n.locale === 'pl'"><td style="text-align:right; padding-right:5px">{{$t('message.po_rabacie')}}</td><td><span style="color:red">{{$t('message.zl')}}</span></td></tr>
            <tr style="height:10px"></tr>
          </table>
        </div>
      </div>
      <div id="Desc">
      </div>
      </template>

      <!-- <div id="view-button-add" style="width: 100%;text-align: right;">
        <button @click="dodaj()" style="background: #08c834;border: none;width: 120px;padding: 4px;color: white;font-size: 24px;">+</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

export default {
  name: 'WidokAkcesorium',
  mixins: [app],
  // props: ['akcesorium', 'clearView'],
  props: ['clearView'],
  data () {
    return {
      kod: 'WPK000',
      nazwa: 'Własny produkt klienta',
      iloscU: 1,
      akcesorium: {}
    }
  },
  computed: {
    ...mapGetters('app', ['outputs', 'inputs'])
  },
  watch: {
    'outputs.item' (newValue, oldValue) {
      if (JSON.parse(JSON.stringify(oldValue)) !== JSON.parse(JSON.stringify(newValue))) {
        this.akcesorium = newValue
      }
    }
  },
  methods: {
    setAttrSelectedAkcesorium () {
      this.$emit('newAttrAkcesorium', {'kod': this.kod, 'nazwa': this.nazwa, 'iloscU': this.iloscU})
    }
  },
  created () {
    var nameProduct = this.$i18n.messages[this.$i18n.locale]['message']['produkt_klienta']
    this.nazwa = nameProduct
    this.kod = (this.$i18n.locale === 'pl') ? 'WPK000' : 'COP000'
  }
}
</script>

<style scoped>
#TabAttr tr td {
  width:130px
}
#widok {
  background: #fff;
  padding: 10px;
  /* min-height:165px; */
  height:200px;
  box-shadow: 2px 2px 2px #ddd;
}
#Img {
width: 100px;
padding: 0px;
margin-left: 15px;
}
#Img img {
  padding:10px; max-height: 132px;
}
#Desc {
  text-align: left;
}
.price {
  color:white;
  font-weight: bold;
  background: red;
  padding: 2px;
}
.btn {
  line-height: .5;
  padding: 0px;
  line-height: 10px;
}
.btn:focus + .btn, .btn:focus {
    color: #000;
    background-color: none;
    border-color: none;
    box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
    box-shadow: none;
}
.opisTable {
  line-height: 16px;
  font-size: 12px;
}
.wyprzedaz {
color: red;
font-weight: bold;
position: absolute;
transform: rotate(-25deg);
font-size: 18px;
top: 58px;
right: 10px;
width: 130px;
text-align: center;
}
.promocja {
  color: #00abff;
  font-weight: bold;
  position: absolute;
  -webkit-transform: rotate(-25deg);
  transform: rotate(-25deg);
  font-size: 18px;
  top: 58px;
  right: 10px;
  width: 130px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/View/Akcesorium.vue